<template>
  <div class="once-nature-embedder">
    <split-vid
      v-if="dataEm !== null"
      :firstsmall="dataEm['film_liten_fore']"
      :secondsmall="dataEm['film_liten_efter']"
      :first="dataEm['film_stor_fore']"
      :second="dataEm['film_stor_efter']"
      :firstback="dataEm['bakgrundsbild_fore']"
      :secondback="dataEm['bakgrundsbild_efter']"
      :datum="dataEm['datum']"
      :vimeo-id="dataEm['vimeo_id']"
      :is-ios="isIos"
      :text="dataEm['info_text_short']"
    />
  </div>
</template>

<script>
import SplitVid from '@/components/SplitVidFull'
export default {
  name: 'Embedder',
  data () {
    return {
      dataEm: null,
      isIos: false
    }
  },
  props: [],
  computed: {
    vid () {
      return this.$route.query.vid || false
    }
  },
  methods: {
  },
  beforeMount () {
    var userAgent = window.navigator.userAgent
    if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
      this.isIos = true
    }
  },
  mounted () {
    this.dataEm = window.content().videos[this.vid - 1]
    //  console.log('id', this.vid)
    //  console.log('data', this.dataEm)
  },
  components: {SplitVid}
}
</script>

<style scoped>
#app {
  padding-bottom: 0px;
}
.makefullscreen {
  z-index: 9999999;
  position: absolute;
  bottom: 10px;
  right: 10px;
}
.once-nature-embedder {
  background-color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/Embedder.vue